<div class="row">
	<div class="col-md-6">
		<div class="kt-input-icon kt-input-icon--left margin-top-5">
			<input type="text" #productSearchInput class="form-control" [(ngModel)]="searchedKeywords" placeholder="{{ 'FE.PRODUCTGRID.PLACEHOLDERS.SEARCH' | localize }}"  id="productSearchInput">
			<span class="kt-input-icon__icon kt-input-icon__icon--left">
				<span><i class="la la-search"></i></span>
			</span>
		</div>
	</div>
	<div class="col-md-6">
		<div class="kt-subheader__toolbar btn-top-margin">
			<div class="kt-subheader__wrapper">
				<div ngbDropdown [placement]="'bottom-right'" class="dropdown dropdown-inline">
					<a ngbDropdownToggle href="javascript:;" class="btn btn-success kt-subheader__btn-options">
						<!--Excel'e Aktar &nbsp; <i class="la la-angle-down"></i>-->
						{{ 'FE.STOCK.BUTTONS.EXCEL' | localize }} &nbsp; <i class="la la-angle-down"></i>
					</a>
					<div ngbDropdownMenu class="dropdown-menu dropdown-menu-right">
						<!--<a class="dropdown-item" href="javascript:;" (click)="onExportToExcelLite2(true)"><i class="la la-file-image-o"></i>Resimli Aktar</a>-->
						<a class="dropdown-item" href="javascript:;" (click)="onExportToExcelLite2(true, false)"><i class="la la-file-image-o"></i>{{ 'FE.STOCK.BUTTONS.EXCEL.DOWNLOADWITHPICTURE' | localize }}</a>
						
						<a class="dropdown-item" href="javascript:;" 
						 (click)="onExportToExcelLite2(true, true)"><i class="la la-file-image-o"></i>Fotoğraflı Alt Depo Bazında</a>
						<div class="dropdown-divider"></div>
						<!--<a class="dropdown-item" href="javascript:;" (click)="onExportToExcelLite2(false)"><i class="la la-file-text"></i>Resimsiz Aktar</a>-->
						<a class="dropdown-item" href="javascript:;" (click)="onExportToExcelLite2(false, false)"><i class="la la-file-text"></i>{{ 'FE.STOCK.BUTTONS.EXCEL.DOWNLOADWITHOUTPICTURE' | localize }}</a>
						
						<a class="dropdown-item" href="javascript:;"
						 (click)="onExportToExcelLite2(false, true)"><i class="la la-file-image-o"></i>Fotoğrafsız Alt Depo Bazında</a>
					
					</div>
				</div>
				<div ngbDropdown [placement]="'bottom-right'" class="dropdown dropdown-inline">
					<a ngbDropdownToggle href="javascript:;" class="btn kt-subheader__btn-secondary kt-subheader__btn-options">
						{{ 'FE.STOCK.BUTTONS.EXCEL.SORT' | localize }} &nbsp; <i class="la la-sort"></i>
					</a>
					<div ngbDropdownMenu class="dropdown-menu dropdown-menu-right">
						<a class="dropdown-item" href="javascript:;" (click)="onSort('name ASC')"><i class="la la-sort-alpha-asc"></i>{{ 'FE.STOCK.BUTTONS.EXCEL.NAME.ASC' | localize }}</a>
						<a class="dropdown-item" href="javascript:;" (click)="onSort('name DESC')"><i class="la la-sort-alpha-desc"></i>{{ 'FE.STOCK.BUTTONS.EXCEL.NAME.DESC' | localize }}</a>
						<div class="dropdown-divider"></div>
						<a class="dropdown-item" href="javascript:;" (click)="onSort('StockQuantity ASC')"><i class="la la-sort-amount-asc"></i>{{ 'FE.STOCK.BUTTONS.EXCEL.STOCK.ASC' | localize }}</a>
						<a class="dropdown-item" href="javascript:;" (click)="onSort('StockQuantity DESC')"><i class="la la-sort-amount-desc"></i>{{ 'FE.STOCK.BUTTONS.EXCEL.STOCK.DESC' | localize }}</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
